import CustomText from "@components/CustomText";
import ChevronRight from "@assets/svg/ChevronRight";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import React from "react";
import { Dimensions, StyleSheet, TouchableOpacity, View } from "react-native";
import color from "@constants/color";
import CallIcon from "@assets/svg/newCall";
import { useNavigation } from "@react-navigation/native";
import Tag from "@components/Tag";

const CxDetail = ({ item, date, createCall }) => {
  const navigation = useNavigation();

  const seeOrders = () => {
    if (!item?.orders_list) return;
    if (item?.orders_list?.length === 1) {
      navigation.navigate("OrderDetails", {
        order_id: item?.orders_list[0],
      });
    } else {
      navigation.navigate("DailyOrderList", {
        user_id: item?.user_id,
        user_name: item?.user_name,
        date,
      });
    }
  };

  const onPressCall = (phone) => {
    if (createCall) {
      createCall(phone);
    } else {
      handleCallButtonPress(phone, "CX_NUMBER_CLICKED", {
        type: "call",
        user_id: item?.user_id,
        user_name: item?.user_name,
        orders: item?.orders_list,
      });
    }
  };

  return (
    <View style={styles.cxDetail}>
      <View style={styles.cxNameContainer}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <CustomText
            variant="title_16"
            style={{
              color: color.mediumBlack,
              maxWidth: Dimensions.get("window").width * 0.45,
            }}
          >
            {item?.user_name}
          </CustomText>
          {item?.is_priority_cx && (
            <View style={{ marginLeft: 6 }}>
              <Tag text="Priority" />
            </View>
          )}
        </View>

        {/* <TouchableOpacity testID="see_orders" onPress={seeOrders}>
          <View style={{ flexDirection: "row" }}>
            <CustomText variant="subtitle_16" style={styles.orderDekhe}>
              आर्डर देखें
            </CustomText>
            <ChevronRight pathFill="rgba(0, 0, 0, 0.4)" style={styles.arrow} />
          </View>
        </TouchableOpacity> */}
      </View>
      <TouchableOpacity
        testID="call"
        onPress={() => onPressCall(item?.user_phone)}
        style={styles.phoneView}
      >
        <CustomText variant="body_text_3" style={styles.phone}>
          {item?.masked_user_phone || item?.user_phone}
        </CustomText>
        <CallIcon strokeColor="#2195F2" width={18} height={18} />
      </TouchableOpacity>
      <CustomText variant="body_text_3" style={{ color: color.lightBlack }}>
        {item.cx_formatted_address}
      </CustomText>
    </View>
  );
};

const styles = StyleSheet.create({
  cxDetail: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    padding: 12,
    borderRadius: 8,
  },
  cxNameContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  orderDekhe: {
    color: color.lightBlack,
    textDecorationLine: "underline",
  },
  phoneView: { flexDirection: "row", marginBottom: 2 },
  phone: { color: color.lightBlack, marginRight: 10 },
  arrow: { height: 16, width: 16, marginTop: 5, marginLeft: 4 },
});

export default CxDetail;
